import { connect } from 'react-redux';
import { withRouter } from "react-router";
import ManageUser from '../../components/ManageUsers/ManageUser';

const mapState = ({auth: { user }}) => {
    return {
        user: user,
    };
};

export default connect(
mapState,
{},
)(withRouter(ManageUser));